<template>
	<div class="float-right sticky z-30 top-2 pr-4 -mb-6 print:hidden">
		<button type="button" class="btn btn-primary relative btn-circle btn-lg z-20 hover:scale-110" :disabled="loading" @click="$emit('push')">
			<span v-if="loading" class="loading loading-spinner loading-md"></span>
			<PlusIcon v-else class="w-8 h-8"></PlusIcon>
		</button>
		<div v-if="pulsate && !loading" class="btn-circle bg-warning absolute top-0 btn-lg floating-btn-pulsate"></div>
	</div>
</template>

<script lang="ts">
import { PlusIcon } from "@heroicons/vue/24/outline";

export default {
	emits: ['push'],
	props:{
		pulsate: {
			type: Boolean,
			default: false,
		},
		// True while the click's target UI (e.g. an external goal picker) is still loading.
		loading: {
			type: Boolean,
			default: false,
		},
	},
	components: {
		PlusIcon
	},
}
</script>
